const PERSONALITY_PROFILES = {
  vi: {
    Moc: {
      coreTraits: ['chủ động', 'tăng trưởng'],
      strengths: ['kiên trì', 'thích học hỏi'],
      risks: ['dễ phân tán'],
      balanceAdvice: ['bổ sung tính kỷ luật và cấu trúc']
    },
    Hoa: {
      coreTraits: ['nhiệt huyết', 'quyết đoán'],
      strengths: ['truyền cảm hứng'],
      risks: ['nóng vội'],
      balanceAdvice: ['giữ nhịp chậm để tránh quá tải']
    },
    Tho: {
      coreTraits: ['ổn định', 'thực tế'],
      strengths: ['đáng tin cậy'],
      risks: ['bảo thủ'],
      balanceAdvice: ['mở rộng góc nhìn, linh hoạt hơn']
    },
    Kim: {
      coreTraits: ['kỷ luật', 'tinh gọn'],
      strengths: ['logic rõ ràng'],
      risks: ['khắt khe'],
      balanceAdvice: ['tăng sự mềm dẻo trong giao tiếp']
    },
    Thuy: {
      coreTraits: ['linh hoạt', 'quan sát sâu'],
      strengths: ['phân tích tốt'],
      risks: ['do dự'],
      balanceAdvice: ['tăng tính quyết đoán khi cần']
    }
  },
  en: {
    Moc: {
      coreTraits: ['proactive', 'growth-oriented'],
      strengths: ['perseverant', 'curious'],
      risks: ['easily distracted'],
      balanceAdvice: ['build more structure and discipline']
    },
    Hoa: {
      coreTraits: ['energetic', 'decisive'],
      strengths: ['inspiring'],
      risks: ['impatient'],
      balanceAdvice: ['slow down to avoid burnout']
    },
    Tho: {
      coreTraits: ['stable', 'grounded'],
      strengths: ['reliable'],
      risks: ['conservative'],
      balanceAdvice: ['broaden perspectives and stay flexible']
    },
    Kim: {
      coreTraits: ['disciplined', 'precise'],
      strengths: ['clear logic'],
      risks: ['overly strict'],
      balanceAdvice: ['soften communication style']
    },
    Thuy: {
      coreTraits: ['adaptive', 'deep observer'],
      strengths: ['analytical'],
      risks: ['hesitant'],
      balanceAdvice: ['act more decisively when needed']
    }
  }
};

export const getPersonalityProfile = (element, language = 'vi') => (
  PERSONALITY_PROFILES[language]?.[element]
  || PERSONALITY_PROFILES.vi?.[element]
  || null
);

export { PERSONALITY_PROFILES };

// =====================================================
// TEN GODS → Personality Overlay MAP (VI/EN)
// Append-only. Works with PERSONALITY_PROFILES in this file.
// =====================================================

const TEN_GODS_ORDER = [
  'Tỷ Kiên',
  'Kiếp Tài',
  'Thực Thần',
  'Thương Quan',
  'Chính Tài',
  'Thiên Tài',
  'Chính Quan',
  'Thiên Quan',
  'Chính Ấn',
  'Thiên Ấn'
];

/**
 * TEN_GODS_PERSONALITY_MAP:
 * - Mỗi Thập Thần -> bổ sung traits/strengths/risks/balanceAdvice
 * - Có thể mở rộng thêm field (communicationStyle/workStyle/stressPattern) nếu UI cần
 */
export const TEN_GODS_PERSONALITY_MAP = {
  vi: {
    'Tỷ Kiên': {
      coreTraits: ['tự chủ', 'kiên định', 'tính cá nhân rõ'],
      strengths: ['bền bỉ', 'tự ra quyết định', 'chịu trách nhiệm'],
      risks: ['dễ cố chấp', 'khó nhờ hỗ trợ'],
      balanceAdvice: [
        'luyện kỹ năng hợp tác và phân quyền',
        'cập nhật dữ kiện trước khi ‘giữ quan điểm’'
      ],
      communicationStyle: ['nói thẳng và rõ ràng', 'thích tự quyết định'],
      workStyle: ['hợp vai trò chủ động/đầu tàu', 'làm tốt khi mục tiêu rõ'],
      stressPattern: ['khi áp lực dễ ‘ôm hết’', 'khó thừa nhận mệt']
    },
    'Kiếp Tài': {
      coreTraits: ['cạnh tranh', 'gan dạ', 'ưa hành động'],
      strengths: ['dám thử', 'phản ứng nhanh', 'động lực mạnh'],
      risks: ['dễ quá tay', 'dễ ‘ăn thua’ khi bị thách thức'],
      balanceAdvice: [
        'đặt giới hạn rủi ro và kỷ luật dừng nghỉ',
        'tập quyết định theo quy trình thay vì cảm xúc'
      ],
      communicationStyle: ['thẳng, mạnh, đôi khi áp lực'],
      workStyle: ['hợp môi trường tốc độ cao', 'mạnh khi cần ‘đánh nhanh’'],
      stressPattern: ['dễ bốc đồng', 'dễ căng nếu bị cản trở']
    },
    'Thực Thần': {
      coreTraits: ['điềm tĩnh', 'thực tế', 'ưa ổn định'],
      strengths: ['kiên nhẫn', 'tận hưởng quá trình', 'giữ nhịp đều'],
      risks: ['dễ chậm quyết', 'dễ thỏa mãn sớm'],
      balanceAdvice: [
        'đặt mục tiêu tăng trưởng rõ theo giai đoạn',
        'tạo ‘deadline mềm’ để không trì hoãn'
      ],
      communicationStyle: ['nhẹ nhàng, ôn hòa', 'dễ tạo cảm giác an toàn'],
      workStyle: ['hợp vai trò duy trì chất lượng', 'làm tốt việc dài hơi'],
      stressPattern: ['né xung đột', 'ngại thay đổi đột ngột']
    },
    'Thương Quan': {
      coreTraits: ['phản biện', 'tư duy độc lập', 'thích bứt phá'],
      strengths: ['sáng tạo', 'nhìn ra điểm bất hợp lý', 'tối ưu nhanh'],
      risks: ['dễ ‘nói quá thẳng’', 'dễ chống đối quy tắc nếu thấy vô lý'],
      balanceAdvice: [
        'mềm hóa cách diễn đạt',
        'chọn ‘đúng việc’ để phản biện thay vì phản biện mọi lúc'
      ],
      communicationStyle: ['lý lẽ mạnh, hay ‘bắt lỗi’'],
      workStyle: ['hợp cải tiến, đổi mới', 'mạnh khi cần phá thế bế tắc'],
      stressPattern: ['căng khi bị kiểm soát', 'dễ tranh luận gay']
    },
    'Chính Tài': {
      coreTraits: ['kỷ luật', 'thực dụng', 'trọng ổn định'],
      strengths: ['quản lý nguồn lực tốt', 'đáng tin', 'giữ cam kết'],
      risks: ['dễ lo xa', 'ngại rủi ro'],
      balanceAdvice: [
        'giữ linh hoạt trong thay đổi',
        'đặt ngưỡng thử nghiệm nhỏ để không quá ‘an toàn’'
      ],
      communicationStyle: ['rõ ràng, thực tế', 'thích kế hoạch cụ thể'],
      workStyle: ['hợp vận hành, quản trị', 'giỏi tối ưu chi phí/nguồn lực'],
      stressPattern: ['căng khi bất định tài chính/nguồn lực']
    },
    'Thiên Tài': {
      coreTraits: ['nhanh nhạy', 'linh hoạt', 'ưa cơ hội'],
      strengths: ['nhìn ra thời cơ', 'mở rộng quan hệ', 'xoay chuyển tốt'],
      risks: ['dễ phân tán', 'dễ ‘chạy theo cái mới’'],
      balanceAdvice: [
        'giới hạn số mục tiêu song song',
        'có tiêu chí chọn cơ hội và tiêu chí bỏ qua'
      ],
      communicationStyle: ['khéo léo, thuyết phục', 'dễ tạo thiện cảm'],
      workStyle: ['hợp phát triển kinh doanh, mở rộng', 'mạnh trong môi trường biến động'],
      stressPattern: ['dễ chán nếu lặp lại', 'dễ ôm nhiều việc']
    },
    'Chính Quan': {
      coreTraits: ['nguyên tắc', 'trách nhiệm', 'tôn trọng chuẩn mực'],
      strengths: ['đáng tin cậy', 'giữ kỷ luật', 'lãnh đạo theo quy trình'],
      risks: ['dễ cứng nhắc', 'tự áp lực phải ‘đúng’'],
      balanceAdvice: [
        'linh hoạt theo bối cảnh',
        'học cách ủy quyền và chấp nhận ‘đủ tốt’'
      ],
      communicationStyle: ['chuẩn mực, rõ ràng', 'ưu tiên công bằng'],
      workStyle: ['hợp quản lý, tuân thủ', 'mạnh khi hệ thống rõ'],
      stressPattern: ['căng khi thiếu chuẩn/quy tắc', 'sợ sai']
    },
    'Thiên Quan': {
      coreTraits: ['quyết liệt', 'chịu áp lực', 'tinh thần ‘đối đầu’ thử thách'],
      strengths: ['bản lĩnh', 'xử lý khủng hoảng', 'dám chịu trách nhiệm'],
      risks: ['dễ căng thẳng', 'dễ cực đoan khi bị dồn ép'],
      balanceAdvice: [
        'xây cơ chế giảm stress (ngủ/đi bộ/thể thao)',
        'tập ‘hạ nhiệt’ trước khi phản ứng'
      ],
      communicationStyle: ['mạnh, nhanh, trực diện'],
      workStyle: ['hợp môi trường cạnh tranh', 'mạnh khi cần ‘gánh team’'],
      stressPattern: ['dễ quá tải', 'dễ nóng nếu bị khiêu khích']
    },
    'Chính Ấn': {
      coreTraits: ['học hỏi', 'tư duy hệ thống', 'thận trọng'],
      strengths: ['nghiên cứu tốt', 'đào sâu vấn đề', 'kiên trì rèn kỹ năng'],
      risks: ['dễ do dự', 'dễ ‘quá an toàn’'],
      balanceAdvice: ['đặt hạn ra quyết định', 'thử nghiệm nhỏ để giảm sợ sai'],
      communicationStyle: ['chậm – chắc – có căn cứ'],
      workStyle: ['hợp nghiên cứu, đào tạo, chuyên môn'],
      stressPattern: ['overthinking', 'lo khi thiếu dữ kiện']
    },
    'Thiên Ấn': {
      coreTraits: ['trực giác', 'ý tưởng mới', 'đa góc nhìn'],
      strengths: ['sáng tạo', 'kết nối ý tưởng', 'nhạy với tín hiệu tinh tế'],
      risks: ['dễ phân tán', 'dễ ‘nhảy’ chiến lược'],
      balanceAdvice: [
        'chuẩn hóa tiêu chí chọn ý tưởng',
        'giữ 1 lõi ổn định + 1 phần thử nghiệm'
      ],
      communicationStyle: ['giàu liên tưởng, nhiều ví dụ'],
      workStyle: ['hợp sáng tạo, chiến lược, R&D'],
      stressPattern: ['mất ngủ/lo nghĩ khi ý tưởng quá nhiều']
    }
  },
  en: {
    'Tỷ Kiên': {
      coreTraits: ['independent', 'steady', 'strong personal stance'],
      strengths: ['persistent', 'self-directed', 'accountable'],
      risks: ['stubborn', 'reluctant to ask for help'],
      balanceAdvice: ['practice collaboration and delegation', 'update beliefs with new evidence'],
      communicationStyle: ['direct and clear', 'prefers self-decision'],
      workStyle: ['fits ownership/lead roles', 'best with clear goals'],
      stressPattern: ['takes on too much', 'hard to admit fatigue']
    },
    'Kiếp Tài': {
      coreTraits: ['competitive', 'bold', 'action-oriented'],
      strengths: ['willing to try', 'fast reaction', 'high drive'],
      risks: ['overreaching', 'turning things into win/lose'],
      balanceAdvice: [
        'set hard risk limits and rest rules',
        'use process-based decisions over emotions'
      ],
      communicationStyle: ['strong and intense'],
      workStyle: ['fits fast-paced settings', 'good at quick pushes'],
      stressPattern: ['impulsive under pressure', 'irritated by obstacles']
    },
    'Thực Thần': {
      coreTraits: ['calm', 'practical', 'stability-seeking'],
      strengths: ['patient', 'process-enjoying', 'steady cadence'],
      risks: ['slow decisions', 'settling too early'],
      balanceAdvice: ['set staged growth goals', 'use gentle deadlines to avoid drifting'],
      communicationStyle: ['warm and soothing'],
      workStyle: ['fits long-horizon quality work'],
      stressPattern: ['avoids conflict', 'dislikes sudden change']
    },
    'Thương Quan': {
      coreTraits: ['critical thinker', 'independent mind', 'breakthrough-driven'],
      strengths: ['creative', 'spots inconsistencies', 'optimizes fast'],
      risks: ['too blunt', 'pushes against rules'],
      balanceAdvice: ['soften delivery', 'choose when to challenge (not always)'],
      communicationStyle: ['argument-strong, error-spotting'],
      workStyle: ['fits innovation and improvement'],
      stressPattern: ['tense when controlled', 'debates harder under stress']
    },
    'Chính Tài': {
      coreTraits: ['disciplined', 'pragmatic', 'stability-oriented'],
      strengths: ['resource management', 'reliable', 'keeps commitments'],
      risks: ['worry-prone', 'risk-averse'],
      balanceAdvice: [
        'stay flexible with change',
        'run small experiments to avoid over-safety'
      ],
      communicationStyle: ['concrete and plan-focused'],
      workStyle: ['fits operations/management'],
      stressPattern: ['stressed by uncertainty of resources']
    },
    'Thiên Tài': {
      coreTraits: ['opportunity-aware', 'flexible', 'networking-friendly'],
      strengths: ['sees timing', 'builds connections', 'adapts quickly'],
      risks: ['scattered focus', 'chasing novelty'],
      balanceAdvice: ['limit parallel goals', 'define criteria to pick/skip opportunities'],
      communicationStyle: ['persuasive and smooth'],
      workStyle: ['fits business expansion'],
      stressPattern: ['bored by repetition', 'overcommits']
    },
    'Chính Quan': {
      coreTraits: ['principled', 'responsible', 'standards-respecting'],
      strengths: ['reliable', 'disciplined', 'process leadership'],
      risks: ['rigid', 'self-pressure to be ‘right’'],
      balanceAdvice: ['adapt to context', 'delegate and accept ‘good enough’'],
      communicationStyle: ['structured, fairness-focused'],
      workStyle: ['fits management/compliance'],
      stressPattern: ['stressed by unclear rules', 'fear of mistakes']
    },
    'Thiên Quan': {
      coreTraits: ['intense', 'pressure-tolerant', 'challenge-facing'],
      strengths: ['resilient', 'crisis handling', 'takes responsibility'],
      risks: ['stress buildup', 'extremes when cornered'],
      balanceAdvice: ['build stress-down routines', 'cool down before reacting'],
      communicationStyle: ['direct and forceful'],
      workStyle: ['fits competitive environments'],
      stressPattern: ['overload risk', 'heat rises under provocation']
    },
    'Chính Ấn': {
      coreTraits: ['learning-driven', 'systematic', 'careful'],
      strengths: ['research', 'deep analysis', 'skill-building'],
      risks: ['hesitant', 'too cautious'],
      balanceAdvice: ['set decision deadlines', 'small trials to reduce fear of error'],
      communicationStyle: ['slow-but-solid, evidence-based'],
      workStyle: ['fits research/training/expertise'],
      stressPattern: ['overthinking', 'worry without enough data']
    },
    'Thiên Ấn': {
      coreTraits: ['intuitive', 'idea-rich', 'multi-perspective'],
      strengths: ['creative', 'connects dots', 'sensitive to subtle signals'],
      risks: ['scattered', 'strategy-hopping'],
      balanceAdvice: [
        'standardize idea selection criteria',
        'keep a stable core + small experiments'
      ],
      communicationStyle: ['metaphor-rich, example-heavy'],
      workStyle: ['fits creativity/strategy/R&D'],
      stressPattern: ['sleep issues from too many ideas']
    }
  }
};

// ------------------ deterministic helpers + merge ------------------

const _uniq = (xs) => Array.from(new Set((xs || []).filter(Boolean)));

const _walkStrings = (obj, out = []) => {
  if (!obj) return out;
  if (typeof obj === 'string') out.push(obj);
  else if (Array.isArray(obj)) obj.forEach((x) => _walkStrings(x, out));
  else if (typeof obj === 'object') Object.values(obj).forEach((x) => _walkStrings(x, out));
  return out;
};

/**
 * extractTenGodCounts(ctx):
 * - tolerant: ctx.thapThan can be array/object/map; we scan all strings and count known labels.
 * - If bạn muốn đếm “chuẩn tuyệt đối” theo schema riêng, bạn dán mẫu ctx.thapThan là mình chỉnh ngay.
 */
export const extractTenGodCounts = (ctx) => {
  const raw = ctx?.thapThan || ctx?.chart?.thapThan || ctx?.result?.thapThan;
  const bag = _walkStrings(raw, []).join(' | ');
  const counts = Object.fromEntries(TEN_GODS_ORDER.map((key) => [key, 0]));

  TEN_GODS_ORDER.forEach((key) => {
    const matches = bag.split(key).length - 1;
    counts[key] = Math.max(0, matches);
  });

  return counts;
};

export const getTopTenGods = (ctx, topN = 2) => {
  const counts = extractTenGodCounts(ctx);
  return Object.entries(counts)
    .sort(
      (a, b) => (b[1] - a[1]) || (TEN_GODS_ORDER.indexOf(a[0]) - TEN_GODS_ORDER.indexOf(b[0]))
    )
    .filter(([, count]) => count > 0)
    .slice(0, topN)
    .map(([key]) => key);
};

/**
 * buildPersonalityProfileCombined(element, ctx, language='vi', topN=2)
 * - Base: PERSONALITY_PROFILES[language][element]
 * - Overlay: TEN_GODS_PERSONALITY_MAP[language][topTenGods]
 * - Deterministic merge: concat arrays + unique
 */
export const buildPersonalityProfileCombined = (element, ctx, language = 'vi', topN = 2) => {
  const base =
    PERSONALITY_PROFILES?.[language]?.[element]
    || PERSONALITY_PROFILES?.vi?.[element]
    || null;

  const tenGods = getTopTenGods(ctx, topN);

  const overlays = tenGods
    .map(
      (tenGod) => TEN_GODS_PERSONALITY_MAP?.[language]?.[tenGod]
        || TEN_GODS_PERSONALITY_MAP?.vi?.[tenGod]
    )
    .filter(Boolean);

  const merged = {
    element,
    tenGods,
    coreTraits: _uniq([...(base?.coreTraits || []), ...overlays.flatMap((o) => o.coreTraits || [])]),
    strengths: _uniq([...(base?.strengths || []), ...overlays.flatMap((o) => o.strengths || [])]),
    risks: _uniq([...(base?.risks || []), ...overlays.flatMap((o) => o.risks || [])]),
    balanceAdvice: _uniq([
      ...(base?.balanceAdvice || []),
      ...overlays.flatMap((o) => o.balanceAdvice || [])
    ]),
    communicationStyle: _uniq(overlays.flatMap((o) => o.communicationStyle || [])),
    workStyle: _uniq(overlays.flatMap((o) => o.workStyle || [])),
    stressPattern: _uniq(overlays.flatMap((o) => o.stressPattern || []))
  };

  if (base?.communicationStyle) {
    merged.communicationStyle = _uniq([
      ...(base.communicationStyle || []),
      ...merged.communicationStyle
    ]);
  }
  if (base?.workStyle) {
    merged.workStyle = _uniq([...(base.workStyle || []), ...merged.workStyle]);
  }
  if (base?.stressPattern) {
    merged.stressPattern = _uniq([...(base.stressPattern || []), ...merged.stressPattern]);
  }

  return merged;
};
